export enum ContractEditMode {
  CREATE,
  DUPLICATE,
  EDIT,
}